import Prestation, {IPrestation} from "@/model/Prestation"
import hasInsuranceContent, {IHasInsuranceContent} from "@/model/mixins/Content/hasInsuranceContent"
import hasInsuranceFamily, {IHasInsuranceFamily} from "@/model/mixins/InsuranceFamily/hasInsuranceFamily"
import hasBaseInsuranceQuoteObject, {IHasBaseInsuranceQuoteObject} from "@/model/mixins/hasBaseInsuranceQuoteObject"


class InsuranceBase extends Prestation {

    constructor(
        id: string,
        quantity?: number,
        startDate?: string,
        endDate?: string,
    ) {
        super(
            id,
            quantity,
            startDate,
            endDate,
        )
    }

}

export interface IInsurance extends InsuranceBase, IPrestation, IHasInsuranceContent, IHasBaseInsuranceQuoteObject, IHasInsuranceFamily {}

// apply mixins
const Insurance: Constructor<IInsurance> = hasBaseInsuranceQuoteObject(hasInsuranceFamily(hasInsuranceContent(InsuranceBase)))

export default Insurance